<template>
  <div>
    <v-dialog width="800" height="800" v-model="notify">
      <v-card flat tile>
        <v-window v-model="onboarding" reverse>
          <v-window-item v-for="(communication, index) in notRead" :key="index">
            <CommunicationView :key="index" :communication="communication" />
          </v-window-item>
        </v-window>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="prev">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-item-group v-model="onboarding" class="text-center" mandatory>
            <v-item
              v-for="n in notRead.length"
              :key="`btn-${n}`"
              v-slot="{ active, toggle }"
            >
              <v-btn :input-value="active" icon @click="toggle">
                <v-icon>mdi-record</v-icon>
              </v-btn>
            </v-item>
          </v-item-group>
          <v-btn text @click="next">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="d-flex align-center">
      <v-btn title="Comunicados" icon @click="viewCommunication">
        <v-badge
          :content="countCommunications()"
          :value="countCommunications()"
          color="red"
          overlap
        >
          <v-icon>
            mdi-mail
          </v-icon>
        </v-badge>
      </v-btn>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import store from "../../modules/communications/_store";
import { mapActions, mapGetters } from "vuex";
import CommunicationView from "../../modules/communications/_components/view";
export default {
  components: {
    CommunicationView
  },
  beforeCreate() {
    const STORE_COMMUNICATION = "$_communication";
    if (!(STORE_COMMUNICATION in this.$store._modules.root._children))
      this.$store.registerModule(STORE_COMMUNICATION, store);
  },

  data() {
    return {
      notify: false,
      onboarding: 0,
      notRead: []
    };
  },

  watch: {
    communicationsNotification() {
      this.notRead = this.communicationsNotification.filter(
        element => element.view === false
      );
    },
    async notify() {
      if (!this.notify) {
        await this.getCommunicationsNotification({
          limit: -1
        });
      }
    }
  },

  computed: {
    ...mapGetters({
      communicationsNotification: "$_communication/communicationsNotification",
      me: "$_auth/me"
    })
  },

  methods: {
    ...mapActions({
      getCommunicationsNotification:
        "$_communication/getCommunicationsNotification"
    }),

    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },

    close(event) {
      this.notify = event;
    },

    countCommunications() {
      if (this.communicationsNotification.length) {
        var communications = this.communicationsNotification.filter(
          element => element.view === false
        );

        if (communications.length) {
          this.notify = true;
          return communications.length;
        } else return "";
      } else return "";
    },

    viewCommunication() {
      if (this.$route.name !== "communications.index")
        this.$router.push({ name: "communications.index" });
    },

    verifyAuth(me) {
      if (_.hasIn(me, "id") && !this.me.password_reset) return true;
      else return false;
    }
  },

  async mounted() {
    await this.getCommunicationsNotification({
      limit: -1
    });

    var interval = setInterval(() => {
      if (!this.verifyAuth(this.me)) clearInterval(interval);
      else
        this.getCommunicationsNotification({
          limit: -1
        });
    }, 250000);
  }
};
</script>
